import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'
import { snakeCaseKeys } from '@/util'

export default {
  postUsers(user) {
    return defaultClient.post('/users/', user)
  },
  postSimpleUser({ businessLicenseNumber, referralCode }) {
    return defaultClient.post('/users/', { businessLicenseNumber, referralCode })
  },
  /**
   * 로그인 가능한 다른 계정 목록 조회
   *
   * @returns {[{uuid, store: {business_license_number, name}}]}
   */
  getUsersSwitchable() {
    return defaultClient.get('/users/switchables/')
  },

  /**
   * 해당 고객이 가진 다른 계정으로 로그인
   *
   * @param {*} userUuid
   * @returns {access_token}
   */
  postUsersSwitch(userUuid) {
    return defaultClient.post(`/users/switchables/${userUuid}/token/`)
  },
  getUsersCheckDuplication(query) {
    return defaultClient.get(`/users/check-duplication/?${qs.stringify(snakeCaseKeys(query))}`)
  },
  postUsersSignUpErrorRecords(data) {
    return defaultClient.post('/users/sign-up-error-records/', data)
  },
  getUsersSignUpErrorRecords() {
    return defaultClient.get('/users/sign-up-error-records/')
  },
  postUsersPasswordReset(data) {
    return defaultClient.post('/users/password-reset/', data)
  },
}
